export const buttonStyle = {
  width: "100%",
  height: "3.5rem",
  padding: "1rem",
  gap: "0.5rem",
  borderRadius: "0.5rem",
  backgroundColor: "#FFFFFF",
  fontFamily: "Inter",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: "1.21rem",
};

export const nodeStyle = {
  borderRadius: "6.25rem",
  padding: "16px",
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "0.87rem",
  lineHeight: "1rem",
};
